import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { UpCaratIcon } from 'foundations-assets/icons/components/UpCaratIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SingleSkeletonLoader } from '../loading/SingleSkeletonLoader';
import { FscSeatTypeRow } from './FscSeatTypeRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SeatsCardSkeleton = () => /*#__PURE__*/_jsx(CardWrapper, {
  inlineSize: "100%",
  padding: "600",
  children: /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "400",
    "aria-hidden": true,
    children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 20,
      width: "180px"
    }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 16
    }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 16
    })]
  })
});
export const FscSeatsCard = ({
  status,
  banner,
  compareSeats
}) => {
  if (status.type === 'pageLoading') {
    return /*#__PURE__*/_jsx(SeatsCardSkeleton, {});
  }
  const pricesLoading = status.type === 'priceLoading';
  const {
    currencyCode,
    seatTypes,
    availableSeatTypes,
    isOtherSeatOptionsExpanded,
    onToggleOtherSeatOptions,
    onSeatTypeQuantityChange,
    onAddSeatType
  } = status.data;
  let otherSeatOptions = null;
  if (availableSeatTypes.length > 0) {
    otherSeatOptions = /*#__PURE__*/_jsx(Popover, {
      open: isOtherSeatOptionsExpanded,
      onOpenChange: evt => onToggleOtherSeatOptions(evt.currentTarget.value),
      placement: "bottom left",
      content: /*#__PURE__*/_jsx(View, {
        padding: "400",
        maxInlineSize: "320px",
        children: /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          gap: "400",
          children: availableSeatTypes.map(({
            seatTypeId,
            name,
            description
          }) => /*#__PURE__*/_jsxs(Flex, {
            justifyContent: "space-between",
            alignItems: "start",
            gap: "400",
            children: [/*#__PURE__*/_jsxs(View, {
              children: [/*#__PURE__*/_jsx(Text, {
                as: "p",
                typography: "heading-50",
                children: name
              }), description && /*#__PURE__*/_jsx(Text, {
                as: "p",
                typography: "body-100",
                color: "text-core-subtle",
                children: description
              })]
            }), /*#__PURE__*/_jsx(Button, {
              use: "secondary",
              size: "small",
              onClick: () => {
                onAddSeatType(seatTypeId);
                onToggleOtherSeatOptions(false);
              },
              "data-test-id": `${seatTypeId}-add-seat-type-button`,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "fscConfigure.seatsCard.add"
              })
            })]
          }, seatTypeId))
        })
      }),
      children: /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: () => onToggleOtherSeatOptions(!isOtherSeatOptionsExpanded),
        "data-test-id": "other-seat-options-toggle",
        children: /*#__PURE__*/_jsxs(Flex, {
          as: "span",
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "fscConfigure.seatsCard.otherSeatOptions"
          }), isOtherSeatOptionsExpanded ? /*#__PURE__*/_jsx(UpCaratIcon, {}) : /*#__PURE__*/_jsx(DownCaratIcon, {})]
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(CardWrapper, {
    inlineSize: "100%",
    padding: "600",
    children: [/*#__PURE__*/_jsx(ScreenReaderOnly, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "fscConfigure.seatsCard.title"
        })
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "400",
      children: [banner, seatTypes.map((option, index) => /*#__PURE__*/_jsx(View, Object.assign({}, index > 0 && {
        borderBlockStartStyle: 'solid',
        borderBlockStartColor: 'border-core-subtle',
        borderBlockStartWidth: '100',
        paddingBlockStart: '400'
      }, {
        children: /*#__PURE__*/_jsx(FscSeatTypeRow, {
          option: option,
          currencyCode: currencyCode,
          pricesLoading: pricesLoading,
          onQuantityChange: onSeatTypeQuantityChange
        })
      }), option.seatTypeId)), otherSeatOptions && /*#__PURE__*/_jsx(Flex, {
        children: otherSeatOptions
      }), compareSeats && /*#__PURE__*/_jsx(Flex, {
        children: compareSeats
      })]
    })]
  });
};